import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { cloneDeep, isObject } from '@/global/utils/utils'
import { api } from '@/global/services/api'
import { dateService, FORMATS } from '@/global/services/date'

export default {
  methods: {
    onShowCommentDetails (event) {
      const { setFormData } = registeredTabsHandlers?.comments || {}
      const { data } = event || {}
      const clonedData = cloneDeep(data)
      const { showDetails, setDetailsTitle } = this.blockConfig || {}
      const appendToDetailsTitle = clonedData?.user ? this.$t(clonedData.user) + ', ' + dateService.formatFromUtc(clonedData.created_at, FORMATS.datetimeShort) : this.$t('fleet/vehicle.details')
      const detailsTitle = this.$t('fleet/activity.vehicle_comments') + ' - ' + appendToDetailsTitle

      if (typeof setFormData === 'function' && data && isObject(data)) {
        this.commentsDetailsTitle = detailsTitle
        setDetailsTitle?.(detailsTitle)
        setFormData(clonedData)
      }

      showDetails?.()
      this.showCommentsTable = false
      this.showCommentsDetails = true
    },

    onCommentDelete (event) {
      const { id, user, created_at: createdAt } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('fleet/vehicle.comment_delete_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (user || '') + ', ' + (dateService.formatFromUtc(createdAt, FORMATS.datetimeShort)))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.comment_delete_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.commentDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async commentDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.comments || {}

        await api('fleet').delete(`vehicle-comment/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    async commentRemoveImageCallback (event) {
      try {
        const { module, route } = event?.removeApiConfig || {}
        const { uuid: imageUuid, tabKey } = event?.file || {}
        const { index } = event || {}
        const { fetchData } = registeredTableHandlers?.[tabKey] || {}

        if (module && route && imageUuid) {
          await api(module).delete(route + imageUuid)
          this.imagesPreviewDialogConfig.images = this.imagesPreviewDialogConfig.images.filter((_, i) => i !== index)
          if (typeof fetchData === 'function') {
            fetchData()
          }
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
